// ── Per-tenant theming ──
// The app's brand colors resolve through CSS variables (--brand-*, defaults in index.css).
// A per-tenant deployment overrides any subset of them at runtime by rewriting those
// variables on :root. Nothing else in the app has to change — every `B.token` already
// reads the variable.
//
// Source of the override, for a single-tenant-per-deployment model, is a build-time env
// var so it's baked into that tenant's bundle:
//   REACT_APP_BRAND_JSON = {"cyan":"#0a7","sidebar":"#111","cyanDark":"#065"}
// (only the keys you want to change; the rest keep the built-in defaults). You can also call
// applyTenantTheme(obj) directly with a config fetched from an API if you prefer runtime.

// token key (matches shared/theme.js B keys) -> CSS variable name
export const BRAND_TOKENS = {
  cyan:       "--brand-cyan",
  cyanDark:   "--brand-cyan-dark",
  cyanLight:  "--brand-cyan-light",
  cyanMid:    "--brand-cyan-mid",
  amber:      "--brand-amber",
  amberDark:  "--brand-amber-dark",
  amberLight: "--brand-amber-light",
  amberMid:   "--brand-amber-mid",
  black40:    "--brand-black40",
  sidebar:    "--brand-sidebar",
  sidebarHov: "--brand-sidebar-hov",
  sidebarAct: "--brand-sidebar-act",
};

// Apply a tenant's brand overrides to the document root. Safe to call with null/partial.
export function applyTenantTheme(brand) {
  if (!brand || typeof document === "undefined") return;
  const root = document.documentElement;
  for (const [key, cssVar] of Object.entries(BRAND_TOKENS)) {
    const val = brand[key];
    if (val) root.style.setProperty(cssVar, val);
  }
}

// Read the build-time brand config (per-tenant bundle). Returns null if unset/invalid.
export function loadBrandFromEnv() {
  try { return JSON.parse(process.env.REACT_APP_BRAND_JSON || "null"); }
  catch (e) { return null; }
}
